import React, { useState, useEffect, useRef, useCallback } from "react";
import moment from "moment";
import axios from "axios";
import { baseurladdress } from "../baseurl";

import "react-big-calendar/lib/css/react-big-calendar.css";

import Topnavbar from "../dashboard/topnavbar";
import Sidennav from "../dashboard/sidenavbar";

import Swal from "sweetalert2";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

const Punchly = () => {

  const accessstaffid = localStorage.getItem("staffid");
  const accesstoken = localStorage.getItem("token");
  const accessroleid = localStorage.getItem("roleid");

  const [shifttype, setshifttype] = useState([]);
  const [selectedShift, setSelectedShift] = useState("");
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
  const [branchtype, setBranchType] = useState([]);
  const [selectedbranchtype, setSelectedBranchType] = useState("");
  const [tableData, setTableData] = useState([]);
  const [assignedBranches, setAssignedBranches] = useState([]);
  const [isQuickShift, setIsQuickShift] = useState(false);

  // Face punch state
  const [faceEnrolled, setFaceEnrolled] = useState(null);
  const [faceModalOpen, setFaceModalOpen] = useState(false);
  const [faceCameraActive, setFaceCameraActive] = useState(false);
  const [faceLoading, setFaceLoading] = useState(false);
  const [autoScan, setAutoScan] = useState(false);
  const [scanning, setScanning] = useState(false);

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const autoScanRef = useRef(null);
  const capturedImageRef = useRef(null);
  const scanningRef = useRef(false);
  const autoScanAttemptsRef = useRef(0);

  // ─── CHECK ENROLLMENT ON MOUNT ───────────────────────────────────────────
  useEffect(() => {
    if (!accessstaffid) return;
    axios.get(`${baseurladdress}face-hasenrolled/${accessstaffid}`, {
      headers: { Authorization: `Bearer ${accesstoken}` },
    })
      .then((res) => setFaceEnrolled(res.data.enrolled))
      .catch(() => setFaceEnrolled(false));
  }, [accessstaffid]);

  // ─── CAMERA HELPERS ──────────────────────────────────────────────────────
  const startCamera = useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { width: 640, height: 480 } });
      streamRef.current = stream;
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        await videoRef.current.play();
      }
      setFaceCameraActive(true);
    } catch (e) {
      Swal.fire({ icon: "error", title: "Camera Error", text: "Unable to access camera. Please allow camera permission." });
    }
  }, []);

  const stopCamera = useCallback(() => {
    clearInterval(autoScanRef.current);
    setAutoScan(false);
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((t) => t.stop());
      streamRef.current = null;
    }
    setFaceCameraActive(false);
  }, []);

  const captureFrame = useCallback(() => {
    if (!videoRef.current || !canvasRef.current) return null;
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth || 640;
    canvas.height = video.videoHeight || 480;
    canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL("image/jpeg", 0.9);
  }, []);

  // ─── OPEN / CLOSE MODAL ──────────────────────────────────────────────────
  const openFaceModal = () => {
    setAutoScan(false);
    setScanning(false);
    capturedImageRef.current = null;
    setFaceModalOpen(true);
    setTimeout(() => startCamera(), 300);
  };

  const closeFaceModal = () => {
    stopCamera();
    setFaceModalOpen(false);
    setFaceLoading(false);
    setScanning(false);
    setAutoScan(false);
    scanningRef.current = false;
  };

  // ─── AUTO SCAN INTERVAL ───────────────────────────────────────────────────
  useEffect(() => {
    if (autoScan && faceModalOpen) {
      autoScanAttemptsRef.current = 0;
      autoScanRef.current = setInterval(() => {
        handleVerifyCapture(0, null, true);
      }, 2000);
    } else {
      clearInterval(autoScanRef.current);
    }
    return () => {
      clearInterval(autoScanRef.current);
      autoScanAttemptsRef.current = 0;
    };
  }, [autoScan, faceModalOpen]);

  // ─── HANDLE FACE PUNCH BUTTON ────────────────────────────────────────────
  const handleFacePunch = () => {
    if (!selectedbranchtype) {
      Swal.fire({ icon: "warning", title: "Please Select Branch" });
      return;
    }
    if (isQuickShift && !selectedShift) {
      Swal.fire({ icon: "warning", title: "Shift Type Required", text: "Please select shift type" });
      return;
    }
    if (faceEnrolled === false) {
      Swal.fire({
        icon: "info",
        title: "Face Not Enrolled",
        text: "Please go to your Edit Staff page to enroll your face before using Face Punch.",
      });
      return;
    }
    openFaceModal();
  };

  // ─── VERIFY + PUNCH SUBMIT ───────────────────────────────────────────────
  const handleVerifyCapture = async (forcePunch = 0, storedImage = null, isAutoScan = false, continueAssigned = false, overrideShiftId = null) => {
    if (scanningRef.current) return;

    const imageBase64 = storedImage || captureFrame();
    if (!imageBase64) return;

    if (!storedImage) capturedImageRef.current = imageBase64;

    scanningRef.current = true;
    setScanning(true);
    setFaceLoading(true);

    try {
      const res = await axios.post(
        `${baseurladdress}face-verify-punch`,
        {
          staffid: accessstaffid,
          branch_id: selectedbranchtype,
          shift_id: overrideShiftId || selectedShift,
          date: selectedDate,
          force_punch: forcePunch,
          continue_assigned: continueAssigned ? 1 : 0,
          imageBase64,
        },
        { headers: { Authorization: `Bearer ${accesstoken}` } }
      );

      const data = res.data;

      // ── Shift card picker helper ──────────────────────────────────────────
      const showShiftCardPicker = async (title, shifts) => {
        const shiftColors = {
          "Day Shift": "#FFDCE5",
          "Morning Shift": "#DCFCE7",
          "Evening Shift": "#D6EFFF",
          "Night Shift": "#E9D8FD",
          "Afternoon Shift": "#FFF1C2",
          "Fixed Shift": "#D9F8F0",
        };
        function fmtTime(t) {
          const [h, m] = t.split(":");
          let hr = parseInt(h, 10);
          const ap = hr >= 12 ? "PM" : "AM";
          hr = hr % 12 || 12;
          return `${hr}:${m} ${ap}`;
        }
        let cardHtml = `<div class="fp-shift-container">`;
        shifts.forEach(shift => {
          const bg = shiftColors[shift.type_name?.trim()] || "#F5F5F5";
          cardHtml += `
            <label class="fp-shift-card" style="background:${bg};">
              <input type="radio" name="fpSelectedShift" value="${shift.type_id}">
              <div class="fp-shift-content">
                <div class="fp-shift-icon">🕒</div>
                <div class="fp-shift-details">
                  <div class="fp-shift-name">${shift.type_name}</div>
                  <div class="fp-shift-time">${fmtTime(shift.shift_from)} - ${fmtTime(shift.shift_to)}</div>
                </div>
              </div>
            </label>`;
        });
        cardHtml += `</div>`;
        const result = await Swal.fire({
          title,
          html: cardHtml,
          width: "720px",
          showCancelButton: true,
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          customClass: { popup: "fp-shift-popup" },
          allowOutsideClick: false,
          didOpen: () => {
            const s = document.createElement("style");
            s.innerHTML = `
              .fp-shift-container{display:grid;grid-template-columns:repeat(auto-fit,minmax(250px,1fr));gap:18px;margin-top:20px;}
              .fp-shift-card{display:block;cursor:pointer;border-radius:16px;padding:18px;transition:.3s;position:relative;border:2px solid transparent;}
              .fp-shift-card:hover{transform:translateY(-4px);box-shadow:0 10px 25px rgba(0,0,0,.15);}
              .fp-shift-card input{position:absolute;right:15px;top:15px;transform:scale(1.3);}
              .fp-shift-content{display:flex;align-items:center;gap:15px;}
              .fp-shift-icon{width:55px;height:55px;border-radius:50%;background:white;display:flex;justify-content:center;align-items:center;font-size:26px;box-shadow:0 4px 10px rgba(0,0,0,.1);flex-shrink:0;}
              .fp-shift-name{font-size:20px;font-weight:700;color:#222;}
              .fp-shift-time{margin-top:6px;font-size:15px;color:#555;}
              .fp-shift-card:has(input:checked){border:2px solid #4F46E5;box-shadow:0 0 15px rgba(79,70,229,.35);}
              .fp-shift-popup{border-radius:20px!important;}
              .fp-shift-popup .swal2-title{font-size:30px!important;font-weight:700!important;}
              .fp-shift-popup .swal2-confirm{background:#4F46E5!important;border-radius:10px!important;padding:10px 28px!important;}
              .fp-shift-popup .swal2-cancel{border-radius:10px!important;padding:10px 28px!important;}
            `;
            document.head.appendChild(s);
          },
          preConfirm: () => {
            const sel = document.querySelector('input[name="fpSelectedShift"]:checked');
            if (!sel) { Swal.showValidationMessage("Please select a shift"); return false; }
            return sel.value;
          },
        });
        return result.isConfirmed ? result.value : null;
      };

      // ── Assigned shift confirmation ───────────────────────────────────────
      if (data.success === "assigned_shift_confirmation") {
        clearInterval(autoScanRef.current);
        setAutoScan(false);
        closeFaceModal();
        const as = data.assigned_shift;
        const fromTime = moment(as.shift_from, "HH:mm:ss").format("hh:mm A");
        const toTime = moment(as.shift_to, "HH:mm:ss").format("hh:mm A");
        const scoreText = data.similarity_score
          ? `<p style="color:green;font-weight:bold;margin-bottom:8px;">✓ Face recognized (${(data.similarity_score * 100).toFixed(1)}% match)</p>`
          : "";
        const step1 = await Swal.fire({
          title: "",
          html: `
            ${scoreText}
            <div class="fp-assigned-popup">
              <div class="fp-assigned-icon">🕒</div>
              <div class="fp-assigned-title">Assigned Shift</div>
              <div class="fp-assigned-name">${as.type_name}</div>
              <div class="fp-assigned-time">${fromTime} - ${toTime}</div>
              <div class="fp-assigned-message">This shift is already assigned to you.<br>Would you like to continue with this shift?</div>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: "Continue",
          cancelButtonText: "Other Shift",
          width: "500px",
          customClass: { popup: "fp-assigned-popup-wrap" },
          allowOutsideClick: false,
          didOpen: () => {
            const s = document.createElement("style");
            s.innerHTML = `
              .fp-assigned-popup-wrap{border-radius:20px;padding:25px;}
              .fp-assigned-popup{text-align:center;}
              .fp-assigned-icon{width:90px;height:90px;margin:auto;border-radius:50%;background:#EEF2FF;font-size:42px;display:flex;justify-content:center;align-items:center;box-shadow:0 5px 15px rgba(79,70,229,.15);}
              .fp-assigned-title{margin-top:20px;font-size:30px;font-weight:700;color:#222;}
              .fp-assigned-name{margin-top:18px;display:inline-block;background:#EEF2FF;color:#4F46E5;padding:10px 28px;border-radius:30px;font-size:24px;font-weight:700;}
              .fp-assigned-time{margin-top:18px;font-size:18px;color:#666;font-weight:600;}
              .fp-assigned-message{margin-top:22px;font-size:16px;color:#555;line-height:1.6;}
              .fp-assigned-popup-wrap .swal2-confirm{background:#4F46E5!important;border-radius:10px!important;padding:10px 30px!important;font-size:16px!important;}
              .fp-assigned-popup-wrap .swal2-cancel{background:#6B7280!important;border-radius:10px!important;padding:10px 30px!important;font-size:16px!important;}
            `;
            document.head.appendChild(s);
          },
        });
        if (step1.isConfirmed) {
          handleVerifyCapture(0, capturedImageRef.current, false, true);
        } else if (step1.dismiss === Swal.DismissReason.cancel) {
          const others = data.overlapping_shifts || [];
          const pickedId = await showShiftCardPicker("Multiple Shift Required", others);
          if (pickedId) handleVerifyCapture(1, capturedImageRef.current, false, false, pickedId);
        }
        return;
      }

      if (data.success === "branch_and_shift_confirmation") {
        clearInterval(autoScanRef.current);
        setAutoScan(false);
        closeFaceModal();
        const scoreText = data.similarity_score
          ? `<p style="color:green;font-weight:bold;margin-bottom:8px;">✓ Face recognized (${(data.similarity_score * 100).toFixed(1)}% match)</p>`
          : "";
        const warn = await Swal.fire({
          title: "Branch & Shift Changed",
          html: `<div style="text-align:center;">${scoreText}<p>Your selected branch and shift are both different from your assignment.</p><p style="color:red;font-weight:bold;margin-top:8px;">Admin approval will be required.</p></div>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Choose Shift",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
        });
        if (warn.isConfirmed) {
          const pickedId = await showShiftCardPicker("Select Shift", data.all_shifts || []);
          if (pickedId) handleVerifyCapture(1, capturedImageRef.current, false, false, pickedId);
        }
        return;
      }

      if (data.success === "branch_confirmation") {
        clearInterval(autoScanRef.current);
        setAutoScan(false);
        closeFaceModal();
        const scoreText = data.similarity_score
          ? `<p style="color:green;font-weight:bold;margin-bottom:8px;">✓ Face recognized (${(data.similarity_score * 100).toFixed(1)}% match)</p>`
          : "";
        const warn = await Swal.fire({
          title: "Branch Changed",
          html: `<div style="text-align:center;">${scoreText}<p>You are attending from a different branch than your assignment.</p><p style="color:red;font-weight:bold;margin-top:8px;">Admin approval will be required.</p></div>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Choose Shift",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
        });
        if (warn.isConfirmed) {
          const pickedId = await showShiftCardPicker("Select Shift", data.all_shifts || []);
          if (pickedId) handleVerifyCapture(1, capturedImageRef.current, false, false, pickedId);
        }
        return;
      }

      if (data.success === "approval_required") {
        clearInterval(autoScanRef.current);
        setAutoScan(false);
        closeFaceModal();
        const scoreText = data.similarity_score
          ? `<p style="color:green;font-weight:bold;margin-bottom:12px;">✓ Face recognized (${(data.similarity_score * 100).toFixed(1)}% match)</p>`
          : "";
        const assignedLine = data.assigned_shift_name
          ? `<div class="fp-apr-row"><span class="fp-apr-label">Assigned shift</span><span class="fp-apr-val">${data.assigned_shift_name}</span></div>`
          : "";
        const selectedLine = data.selected_shift_name
          ? `<div class="fp-apr-row"><span class="fp-apr-label">Punching for</span><span class="fp-apr-val fp-apr-diff">${data.selected_shift_name}</span></div>`
          : `<div class="fp-apr-row"><span class="fp-apr-label">Shift</span><span class="fp-apr-val fp-apr-diff">Not assigned</span></div>`;
        const confirm = await Swal.fire({
          title: "",
          html: `
            ${scoreText}
            <div class="fp-apr-popup">
              <div class="fp-apr-icon">⚠️</div>
              <div class="fp-apr-title">Admin Approval Required</div>
              <div class="fp-apr-card">
                ${assignedLine}
                ${selectedLine}
              </div>
              <div class="fp-apr-message">Marking this attendance will be sent for admin approval.<br>Do you want to continue?</div>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          width: "480px",
          customClass: { popup: "fp-apr-popup-wrap" },
          allowOutsideClick: false,
          didOpen: () => {
            const s = document.createElement("style");
            s.innerHTML = `
              .fp-apr-popup-wrap{border-radius:20px;padding:25px;}
              .fp-apr-popup{text-align:center;}
              .fp-apr-icon{width:90px;height:90px;margin:auto;border-radius:50%;background:#FEF3C7;font-size:38px;display:flex;justify-content:center;align-items:center;box-shadow:0 5px 15px rgba(245,158,11,.2);}
              .fp-apr-title{margin-top:18px;font-size:26px;font-weight:700;color:#222;}
              .fp-apr-card{margin:18px auto 0;background:#F9FAFB;border-radius:12px;padding:14px 18px;max-width:320px;text-align:left;}
              .fp-apr-row{display:flex;justify-content:space-between;align-items:center;padding:6px 0;border-bottom:1px solid #E5E7EB;}
              .fp-apr-row:last-child{border-bottom:none;}
              .fp-apr-label{font-size:13px;color:#6B7280;font-weight:500;}
              .fp-apr-val{font-size:14px;font-weight:700;color:#111;}
              .fp-apr-diff{color:#DC2626;}
              .fp-apr-message{margin-top:18px;font-size:14px;color:#555;line-height:1.6;}
              .fp-apr-popup-wrap .swal2-confirm{background:#4F46E5!important;border-radius:10px!important;padding:10px 30px!important;font-size:16px!important;}
              .fp-apr-popup-wrap .swal2-cancel{background:#6B7280!important;border-radius:10px!important;padding:10px 30px!important;font-size:16px!important;}
            `;
            document.head.appendChild(s);
          },
        });
        if (confirm.isConfirmed) handleVerifyCapture(1, capturedImageRef.current);
        return;
      }

      if (data.success === true) {
        closeFaceModal();
        Swal.fire({
          icon: "success",
          title: data.punchType === "in" ? "Punched In Successfully" : "Punched Out Successfully",
          text: `Face match score: ${(data.similarity_score * 100).toFixed(1)}%`,
          timer: 2500, showConfirmButton: false,
        });
        GetStaffAttendance();
        return;
      }

      if (data.face_mismatch) {
        if (isAutoScan) {
          autoScanAttemptsRef.current += 1;
          if (autoScanAttemptsRef.current >= 2) {
            autoScanAttemptsRef.current = 0;
            clearInterval(autoScanRef.current);
            setAutoScan(false);
            closeFaceModal();
            Swal.fire({
              icon: "error",
              title: "Face Not Recognized",
              text: "Look directly at the camera in good lighting and try again.",
            });
          }
          return;
        }
        Swal.fire({
          icon: "error",
          title: "Face Not Recognized",
          text: "Look directly at the camera in good lighting and try again.",
        });
        return;
      }

      if (data.not_enrolled) {
        closeFaceModal();
        setFaceEnrolled(false);
        Swal.fire({ icon: "warning", title: "Not Enrolled", text: "Please go to your Edit Staff page to enroll your face." });
        return;
      }

      clearInterval(autoScanRef.current);
      setAutoScan(false);
      closeFaceModal();
      Swal.fire({ icon: "error", title: "Error", text: data.message || "Something went wrong." });

    } catch (err) {
      if (!isAutoScan) {
        Swal.fire({ icon: "error", title: "Server Error", text: err.response?.data?.message || "Unable to process request." });
      }
    } finally {
      scanningRef.current = false;
      setScanning(false);
      setFaceLoading(false);
    }
  };

  // ─── REGULAR PUNCH ───────────────────────────────────────────────────────
  const processPunch = async (forcePunch = 0, continueAssigned = false) => {
    if (!selectedbranchtype) {
      Swal.fire({ icon: "warning", title: "Please Select Branch" });
      return;
    }
    if (isQuickShift && !selectedShift) {
      Swal.fire({ icon: "warning", title: "Shift Type Required", text: "Please select shift type" });
      return;
    }
    try {
      const res = await axios.post(
        `${baseurladdress}punch`,
        {
          staffid: accessstaffid,
          branch_id: selectedbranchtype,
          shift_id: selectedShift,
          date: selectedDate,
          quickshift: isQuickShift ? 1 : 0,
          force_punch: forcePunch,
          continue_assigned: continueAssigned,
          attendance_status: forcePunch === 1 ? 2 : 1,
        },
        { headers: { Authorization: `Bearer ${accesstoken}`, "Content-Type": "application/json" } }
      );

      if (res.data.success === "assigned_shift_confirmation") {
        const { assigned_shift } = res.data;
        const result = await Swal.fire({
          title: "Assigned Shift",
          html: `<div style="text-align:center;">
            <p>Your assigned shift: <strong>${assigned_shift.type_name}</strong></p>
            <p>${assigned_shift.shift_from} – ${assigned_shift.shift_to}</p>
            <p>Do you want to punch with this shift?</p>
          </div>`,
          icon: "info", showCancelButton: true,
          confirmButtonText: "Punch", cancelButtonText: "Cancel",
          confirmButtonColor: "#3085d6", cancelButtonColor: "#d33",
          reverseButtons: true, allowOutsideClick: false, allowEscapeKey: false,
        });
        if (result.isConfirmed) await processPunch(0, true);
        return;
      }

      if (res.data.success === "branch_and_shift_confirmation") {
        const result = await Swal.fire({
          title: "Confirmation Required",
          html: `<div style="text-align:center;">
            <p>This branch is different from your assigned branch.</p>
            <p>This shift is not assigned to you.</p>
            <p style="color:red;font-weight:bold;">You must have approval for this branch and shift.</p>
            <p>Are you sure you want to continue?</p>
          </div>`,
          icon: "warning", showCancelButton: true, confirmButtonText: "Continue", cancelButtonText: "Cancel",
          confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", reverseButtons: true, allowOutsideClick: false, allowEscapeKey: false,
        });
        if (result.isConfirmed) await processPunch(1);
        return;
      }

      if (res.data.success === "branch_confirmation") {
        const result = await Swal.fire({
          title: "Branch Changed",
          html: `<div style="text-align:center;">
            <p>This branch is different from your assigned branch.</p>
            <p>Are you sure you want to continue?</p>
            <p style="color:red;font-weight:bold;">You may require approval for this branch.</p>
          </div>`,
          icon: "warning", showCancelButton: true, confirmButtonText: "Continue", cancelButtonText: "Cancel",
          confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", reverseButtons: true, allowOutsideClick: false, allowEscapeKey: false,
        });
        if (result.isConfirmed) await processPunch(1);
        return;
      }

      if (res.data.success === "approval_required") {
        const result = await Swal.fire({
          title: "Shift Not Assigned",
          html: `<div style="text-align:center;">
            <p>This shift is not assigned to you.</p>
            <p>Are you sure you want to login?</p>
            <p style="color:red;font-weight:bold;">You must have approval for this shift.</p>
          </div>`,
          icon: "warning", showCancelButton: true, confirmButtonText: "Continue", cancelButtonText: "Cancel",
          confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", reverseButtons: true, allowOutsideClick: false, allowEscapeKey: false,
        });
        if (result.isConfirmed) await processPunch(1);
        return;
      }

      if (res.data.success === true) {
        const punchType = res.data.punchType;
        Swal.fire({
          icon: "success",
          title: punchType === "in" ? "Punched In Successfully" : "Punched Out Successfully",
          timer: 2000, showConfirmButton: false,
        });
        GetStaffAttendance();
        return;
      }

      Swal.fire({ icon: "error", title: "Error", text: res.data.message || "Something went wrong" });

    } catch (err) {
      Swal.fire({ icon: "error", title: "Server Error", text: err.response?.data?.message || "Unable to process request" });
    }
  };

  const handlePunch = () => processPunch(0);

  // ─── FETCH BRANCHES ──────────────────────────────────────────────────────
  useEffect(() => {
    const fetchData = async () => {
      try {
        const staffid = localStorage.getItem("staffid");
        const branchRes = await axios.get(`${baseurladdress}getallbranchestype`, {
          headers: { Authorization: `Bearer ${accesstoken}` },
        });
        setBranchType(branchRes.data.response || []);

        const empBranchRes = await axios.get(`${baseurladdress}getemployeebranchdetails/${staffid}`, {
          headers: { Authorization: `Bearer ${accesstoken}` },
        });
        if (empBranchRes.data.response) {
          setSelectedBranchType(empBranchRes.data.response.branch_id.toString());
        }
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error Loading Data" });
      }
    };
    fetchData();
  }, []);

  // ─── GET STAFF ASSIGNED BRANCHES ─────────────────────────────────────────
  useEffect(() => {
    const getAssignedBranches = async () => {
      try {
        const res = await axios.get(`${baseurladdress}getstaffassignedbranches/${accessstaffid}/${selectedDate}`, {
          headers: { Authorization: `Bearer ${accesstoken}` },
        });
        setAssignedBranches(res.data.response || []);
      } catch (error) {
        console.log("ASSIGNED BRANCH ERROR:", error);
      }
    };
    getAssignedBranches();
  }, [selectedDate]);

  // ─── GET ATTENDANCE (role-aware) ──────────────────────────────────────────
  const GetStaffAttendance = () => {
    const staffid = localStorage.getItem("staffid");
    const roleid = localStorage.getItem("roleid");

    axios.get(`${baseurladdress}getstaffattendancee/${staffid}?roleid=${roleid}`, {
      headers: { Authorization: `Bearer ${accesstoken}` },
    })
      .then((res) => {
        const datas = res.data.response || [];
        const tdata = datas.map((item, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{item.staff_name}</td>
            <td>{item.shift_name}</td>
            <td>{item.branch_name}</td>
            <td>{moment(item.punch_date).format("DD-MM-YYYY")}</td>
            <td>{item.punch_in ? moment(item.punch_in, "HH:mm:ss").format("hh:mm:ss A") : "-"}</td>
            <td>{item.punch_out ? moment(item.punch_out, "HH:mm:ss").format("hh:mm:ss A") : "-"}</td>
          </tr>
        ));
        setTableData(tdata);
        if ($.fn.DataTable.isDataTable("#attendancelist")) {
          $("#attendancelist").DataTable().destroy();
        }
        setTimeout(() => $("#attendancelist").DataTable(), 500);
      })
      .catch(() => {
        Swal.fire({ icon: "error", title: "No Attendance Found" });
      });
  };

  useEffect(() => { GetStaffAttendance(); }, []);

  // ─── GET SHIFT TYPES ─────────────────────────────────────────────────────
  useEffect(() => {
    axios.get(`${baseurladdress}getallshifttype`, { headers: { Authorization: `Bearer ${accesstoken}` } })
      .then((res) => setshifttype(res.data.response))
      .catch((error) => console.log(error));
  }, []);

  // ─── AUTO-SELECT TODAY'S ASSIGNMENT ──────────────────────────────────────
  useEffect(() => {
    const getTodayAssignment = async () => {
      try {
        const res = await axios.get(`${baseurladdress}getstafftodayassignment/${accessstaffid}/${selectedDate}`, {
          headers: { Authorization: `Bearer ${accesstoken}` },
        });
        if (res.data.response && res.data.response.length > 0) {
          const assignment = res.data.response[0];
          setSelectedBranchType(String(assignment.branch_id));
          setSelectedShift(String(assignment.shift_id));
          setIsQuickShift(false);
        }
      } catch (err) {
        console.log("TODAY ASSIGNMENT ERROR:", err.response?.data || err);
      }
    };
    getTodayAssignment();
  }, [selectedDate]);

  // ─── RENDER ──────────────────────────────────────────────────────────────
  return (
    <>
      <Topnavbar />
      <Sidennav />

      {/* ── FACE CAMERA MODAL ─────────────────────────────────────────── */}
      {faceModalOpen && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
          background: "rgba(0,0,0,0.75)", zIndex: 9999,
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <style>{`
            @keyframes scanLine {
              0%   { top: 0%; }
              100% { top: 100%; }
            }
            .swal2-container { z-index: 99999 !important; }
          `}</style>

          <div style={{
            background: "#fff", borderRadius: "12px", padding: "24px",
            width: "500px", maxWidth: "95vw", textAlign: "center",
          }}>
            <h5 style={{ marginBottom: "6px" }}>Face Verification</h5>
            <p style={{ color: "#666", fontSize: "13px", marginBottom: "12px" }}>
              {autoScan
                ? "Auto scanning every 3 seconds. Hold still and face the camera."
                : "Look directly at the camera, then click Capture & Punch."}
            </p>

            {/* VIDEO + SCAN LINE */}
            <div style={{ position: "relative", display: "inline-block", borderRadius: "8px", overflow: "hidden", border: `2px solid ${autoScan ? "#0d6efd" : "#dee2e6"}`, width: "100%" }}>
              <video
                ref={videoRef}
                style={{ width: "100%", display: "block", transform: "scaleX(-1)" }}
                playsInline
                muted
              />
              {(scanning || autoScan) && (
                <div style={{
                  position: "absolute", left: 0, right: 0, height: "3px",
                  background: "linear-gradient(90deg, transparent, #0d6efd, transparent)",
                  animation: "scanLine 1.8s linear infinite",
                  pointerEvents: "none",
                }} />
              )}
              <canvas ref={canvasRef} style={{ display: "none" }} />
            </div>

            {/* AUTO SCAN STATUS BADGE */}
            {autoScan && (
              <div style={{ marginTop: "8px", color: "#0d6efd", fontSize: "13px", fontWeight: 600 }}>
                🔄 Scanning... ({scanning ? "processing" : "waiting"})
              </div>
            )}

            {/* BUTTONS */}
            <div style={{ marginTop: "10px", display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap" }}>
              <button
                className="btn btn-success"
                onClick={() => handleVerifyCapture(0)}
                disabled={scanning || !faceCameraActive || autoScan}
              >
                {scanning && !autoScan ? "Verifying..." : "Capture & Punch"}
              </button>
              <button
                className={`btn ${autoScan ? "btn-warning" : "btn-outline-primary"}`}
                onClick={() => setAutoScan((v) => !v)}
                disabled={!faceCameraActive}
              >
                {autoScan ? "⏹ Stop Auto" : "⚡ Auto Scan"}
              </button>
              <button className="btn btn-secondary" onClick={closeFaceModal} disabled={scanning && !autoScan}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="content-wrap">
        <div className="main">
          <div className="container-fluid">
            <section id="main-content">
              <div className="card">
                <div className="card-header">
                  <h6 className="card-title">Attendance</h6>
                </div>

                <div className="card-body">
                  <div style={{ display: "flex", gap: "20px", marginTop: "20px", alignItems: "center", flexWrap: "wrap" }}>

                    {/* BRANCH */}
                    <div className="col-sm-4 mt-2">
                      <select
                        className="form-control"
                        value={selectedbranchtype}
                        onChange={(e) => {
                          const branchId = e.target.value;
                          setSelectedBranchType(branchId);
                          const exists = assignedBranches.some((item) => String(item.branch_id) === String(branchId));
                          if (!exists) { setIsQuickShift(true); }
                          else { setIsQuickShift(false); setSelectedShift(""); }
                        }}
                      >
                        <option value="">Select branch</option>
                        {branchtype.map((branch) => (
                          <option key={branch.branch_id} value={branch.branch_id.toString()}>
                            {branch.branch_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* SHIFT */}
                    <div className="col-sm-4 mt-2">
                      <select
                        className="form-control"
                        value={selectedShift || ""}
                        onChange={(e) => setSelectedShift(e.target.value)}
                      >
                        <option value="">Select Shift Type</option>
                        {shifttype.map((item) => (
                          <option key={item.type_id} value={String(item.type_id)}>
                            {item.type_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* PUNCH BUTTONS */}
                    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
                      <button className="btn btn-success" onClick={handlePunch}>
                        Punch In / Out
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={handleFacePunch}
                        title={faceEnrolled === false ? "Go to Edit Staff page to enroll your face" : "Punch using face recognition"}
                      >
                        {faceEnrolled === false ? "Face Punch (Not Enrolled)" : "Face Punch"}
                      </button>
                    </div>

                  </div>

                  {/* DATE */}
                  <div style={{ marginTop: "20px", maxWidth: "250px" }}>
                    <label className="form-label">Select Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                    />
                  </div>

                  {/* TABLE */}
                  <div style={{ marginTop: "40px" }}>
                    <div className="table-responsive">
                      <table className="table table-bordered" id="attendancelist">
                        <thead>
                          <tr>
                            <th>Sl No</th>
                            <th>Staff Name</th>
                            <th>Shift Name</th>
                            <th>Branch</th>
                            <th>Date</th>
                            <th>Punch In</th>
                            <th>Punch Out</th>
                          </tr>
                        </thead>
                        <tbody>{tableData}</tbody>
                      </table>
                    </div>
                  </div>

                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Punchly;
